(() => {
  if (customElements.get('jb-collection-refinements')) return;
  const defaults = () => ({ shape: '', metal: '', band: '' });
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const normalize = value => (value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  const metalKeys = value => ['white', 'yellow', 'rose'].filter(key => normalize(value).includes(key));
  const bandMap = {"floral-pear-engagement-ring-1":"pave","floral-oval-engagement-ring-4":"plain","floral-marquise-engagement-ring-3":"pave","floral-marquise-engagement-ring-2":"plain","contemporary-solitaire-plus-hidden-halo-engagement-ring":"plain","6-prong-floral-engagement-ring-1":"pave","floral-princess-cut-engagement-ring-3":"pave","floral-princess-cut-engagement-ring-2":"plain","floral-marquise-engagement-ring-1":"pave","floral-marquise-engagement-ring":"plain","floral-emerald-cut-engagement-ring-1":"pave","floral-emerald-cut-engagement-ring":"plain","floral-engagement-ring-1":"plain","split-shank-round-halo-engagement-ring":"pave","split-shank-pear-halo-engagement-ring":"pave","split-shank-marquise-halo-engagement-ring":"pave","solitaire-knife-edge-princess-cut-engagement-ring-1":"plain","solitaire-knife-edge-oval-engagement-ring":"plain","multirow-pave-engagement-ring":"pave","solitaire-engagement-ring-3":"plain","solitaire-round-diamond-engagement-ring":"plain","single-row-engagement-ring":"pave","solitaire-engagement-ring-2":"plain","solitaire-engagement-ring-1":"plain","solitaire-knife-edge-princess-cut-engagement-ring":"plain","hidden-halo-oval-engagement-ring-3":"plain","solitaire-knife-edge-round-engagement-ring":"plain","princess-cut-hidden-halo-engagement-ring":"pave","double-hidden-halo-emerald-cut-engagement-ring":"plain","6-prong-solitaire-emerald-cut-engagement-ring":"plain","floral-inspired-pear-engagement-ring-1":"pave","floral-inspired-pear-engagement-ring":"plain","floral-oval-engagement-ring-3":"pave","engagement-ring":"pave","hidden-halo-round-engagement-ring-1":"pave","double-hidden-halo-marquise-engagement-ring":"plain","solitaire-marquise-engagement-ring-3":"plain","hidden-halo-princess-cut-engagement-ring":"plain","floral-pear-engagement-ring":"pave","floral-oval-engagement-ring-2":"plain","floral-engagement-ring":"pave","floral-round-engagement-ring":"plain","contemporary-floral-emerald-cut-engagement-ring":"plain","floral-oval-engagement-ring-1":"pave","round-split-shank-engagement-ring":"plain","solitaire-emerald-cut-engagement-ring-3":"plain","6-prong-floral-engagement-ring":"plain","solitaire-oval-engagement-ring-5":"plain","floral-princess-cut-engagement-ring-1":"pave","split-shank-emerald-cut-halo-engagement-ring":"pave","hidden-halo-marquise-engagement-ring-1":"pave","solitaire-princess-cut-engagement-ring-3":"plain","solitaire-pear-shape-1":"plain","3-stone-ring-mq-ctr-tb-sides":"plain","solitaire-oval-engagement-ring-4":"plain","engagement-rings-em-center":"pave","double-hidden-halo-oval-engagement-ring":"plain","6-prong-round-solitaire-engagement-ring":"plain","round-solitaire-engagement-ring-2":"plain","prong-set-emerald-cut-hidden-halo-engagement-ring":"pave","double-hidden-halo-round-engagement-ring":"plain","single-row-marquise-engagement-ring":"pave","solitaire-princess-cut-engagement-ring-2":"plain","3-stone-ov-ctr-tb-sides":"plain","round-hidden-halo-engagement-ring-2":"pave","hidden-halo-emerald-cut-engagement-ring-2":"plain","round-hidden-halo-engagement-ring-1":"plain","prong-set-halo-engagement-ring":"pave","3-stone-ring-sq-ctr-tb-sides":"plain","single-row-hidden-halo-round-engagement-ring":"pave","single-row-trellis-shared-prong-engagement-ring":"pave","oval-hidden-halo-engagement-ring-1":"plain","ps-hidden-halo-engagement":"pave","solitaire-round-engagement-ring-1":"plain","solitaire-7x7-cushion":"plain","round-hidden-halo-engagement-ring":"plain","3-stone-emerald-engagement-ring-w-pear-sides":"plain","single-row-princess-cut-engagement-ring":"pave","3-stone-pear-baguette-engagement-ring":"plain","3-stone-round-engagement-ring-w-pear-sides":"plain","solitaire-round-engagement-ring":"plain","hidden-halo-pc-center-single-row":"pave","solitaire-marquise-engagement-ring-2":"plain","single-row-round-engagement-ring":"pave","round-solitaire-engagement-ring-1":"plain","single-row-oval-engagement-ring":"pave","solitaire-oval-engagement-ring-3":"plain","engagement-ring-oval-cent":"pave","solitaire-cushion-cut-engagement-ring":"plain","3-stone-ring-rd-ctr-tb-sides":"plain","6-prong-round-tulip-solitaire-engagement-ring":"plain","solitaire-emerald-cut-engagement-ring-2":"plain","solitaire-trellis-engagement-ring":"plain","hidden-halo-emerald-cut-engagement-ring-1":"pave","3-stone-round-pear-shape-engagement-ring":"plain","hidden-halo-pear-shape-engagement-rings":"pave","pear-shape-solitaire-engagement-rings":"plain","solitaire-round-engagement-rings":"plain","solitaire-oval-engagement-ring-2":"plain","solitaire-oval-engagement-ring-1":"plain","solitaire-oval-engagement-ring":"plain","tapered-baguette-3-stone-emerald-cut-engagement-ring":"plain","solitaire-engagement-ring":"plain","hidden-halo-oval-engagement-ring-2":"pave","solitaire-emerald-cut-engagement-ring-1":"plain","solitaire-cathedral-emerald-cut-engagement-ring":"plain","6-prong-single-row-round-engagement-ring":"pave","hidden-halo-emerald-cut-engagement-ring":"plain","hidden-halo-round-engagement-ring":"plain","solitaire-round-engagment":"plain","hidden-halo-oval-engagement-ring-1":"plain","oval-hidden-halo-engagement-ring":"pave","oval-tulip-solitaire-engagement-ring":"plain","2-stone-round-pear-engagement-ring":"plain","round-solitaire-engagement-ring":"plain","split-shank-swirl-ring":"pave","emerald-1ct-plus-ring":"plain","3-stone-engagement-ring-1":"plain","3-stone-engagement-ring":"plain","multirow-pave-halo-engagement-ring":"pave","3-stone-oval-engagement-ring-w-pear-sides":"plain","intertwined-engagement-ring":"pave","pc-single-row-shared-pr-eng-ring":"pave","cu-single-row-shared-pr-eng-ring":"pave","oval-single-row-shared-pr-eng-ring":"pave","single-row-shared-prong-trellis-engagement-ring":"pave","pear-shape-single-row-shared-pr-en":"pave","modern-emerald-cut-bezel-set-engagement-ring":"plain","domed-bezel-set-oval-engagement-ring":"plain","hidden-halo-oval-engagement-ring":"pave","bezel-set-princess-cut-solitaire-engagement-ring":"plain","bezel-set-oval-solitaire-engagement-ring":"plain","bezel-set-marquise-solitaire-engagement-ring":"plain","bezel-set-emerald-cut-solitaire-engagement-ring":"plain","bezel-set-cushion-solitaire-engagement-ring":"plain","bezel-set-pear-solitaire-engagement-ring":"plain","hidden-halo-marquise-engagement-ring":"plain","single-row-hidden-halo-square-engagement-ring":"pave","pear-shaped-hidden-halo-engagement-ring":"plain","braided-shank-round-cut-engagement-ring":"plain","twisting-diamond-accented-engagement-ring":"pave","solitaire-bezel-set-engagement-ring":"plain","accented-trellis-emerald-cut-engagement-ring":"pave","accented-trellis-oval-engagement-ring":"pave","double-hidden-halo-princess-cut-engagement-ring":"plain","double-hidden-halo-pear-engagement-ring":"plain","solitaire-cushion-engagement-ring":"plain","solitaire-princess-cut-engagement-ring-1":"plain","solitaire-pear-shape":"plain","solitaire-emerald-cut":"plain","solitaire-marquise-engagement-ring-1":"plain","solitaire-emerald-cut-engagement-ring":"plain","6-prong-solitaire-marquise-engagement-ring":"plain","solitaire-marquise-engagement-ring":"plain","solitaire-princess-cut-engagement-ring":"plain","solitaire-7-5x5-25-pear-shape":"plain","6-prong-oval-solitaire-engagement-ring":"plain","floral-princess-cut-engagement-ring":"plain"};
  class JBRefinements extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.labels = JSON.parse(this.querySelector('[data-jbr-labels]').textContent);
      this.grid = this.querySelector('#product-grid');
      this.dialog = this.querySelector('dialog');
      this.applied = defaults();
      this.draft = defaults();
      this.catalog = null;
      this.revision = 0;
      this.limit = 24;
      this.cards = new Map();
      this.original = [...(this.grid?.children || [])];
      this.result = this.querySelector('.jbr-results');
      this.pagination = [...this.result.children].filter(node => node.tagName !== 'JB-CATALOG-LAYOUT');
      this.more = document.createElement('button');
      this.more.type = 'button';
      this.more.className = 'jbr-more';
      this.more.textContent = this.labels.more;
      this.more.hidden = true;
      this.result.append(this.more);
      this.status = document.createElement('p');
      this.status.className = 'jbr-status visually-hidden';
      this.status.setAttribute('role', 'status');
      this.result.append(this.status);
      this.empty = document.createElement('div');
      this.empty.className = 'jbr-empty';
      this.empty.hidden = true;
      const emptyText = document.createElement('p');
      emptyText.textContent = this.labels.empty;
      const clear = document.createElement('button');
      clear.type = 'button';
      clear.className = 'jbr-clear';
      clear.dataset.reset = '';
      clear.textContent = this.labels.clear;
      this.empty.append(emptyText, clear);
      this.result.append(this.empty);
      this.addEventListener('click', event => this.onClick(event), { signal });
      this.gridObserver = new MutationObserver(() => {
        if (!this.hasFilters(this.applied) && !this.pendingState) this.original = [...this.grid.children];
        this.updateProgress();
      });
      this.gridObserver.observe(this.grid, { childList: true });
      this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.closePanel(); }, { signal });
      this.dialog.addEventListener('close', () => {
        if (this.dialog.open) return;
        this.panelAnimation?.cancel();
        this.panelAnimation = null;
        this.dialog.dataset.motion = 'closed';
        document.documentElement.style.overflow = this.oldOverflow || '';
        this.querySelectorAll('[data-open],[data-open-sort]').forEach(button => button.setAttribute('aria-expanded', 'false'));
        this.panelOpener?.focus({ preventScroll: true });
      }, { signal });
      reduced.addEventListener?.('change', () => { if (reduced.matches) this.panelAnimation?.finish(); }, { signal });
      this.more.addEventListener('click', () => { this.limit += 24; this.renderProducts(); }, { signal });
      this.rail = this.querySelector('.jbr-rail');
      this.railScroller = this.querySelector('.jbr-rail-scroll');
      this.scheduleRailViewport = () => {
        if (this.railViewportFrame) return;
        this.railViewportFrame = requestAnimationFrame(() => {
          this.railViewportFrame = null;
          this.updateRailViewport();
        });
      };
      window.addEventListener('scroll', this.scheduleRailViewport, { signal, passive: true });
      window.addEventListener('resize', this.scheduleRailViewport, { signal, passive: true });
      window.visualViewport?.addEventListener('resize', this.scheduleRailViewport, { signal, passive: true });
      this.resize = new ResizeObserver(() => this.updateHeader());
      const header = document.querySelector('#header');
      if (header) this.resize.observe(header);
      this.updateHeader();
      this.media = matchMedia('(min-width:768px)');
      this.media.addEventListener('change', () => { if (this.media.matches && this.dialog.open) this.closePanel(); }, { signal });
      window.addEventListener('popstate', () => {
        this.readURL();
        this.draft = { ...this.applied };
        this.loadCatalog().then(() => this.renderProducts()).catch(() => {});
        this.renderControls();
      }, { signal });
      this.readURL();
      this.draft = { ...this.applied };
      this.renderControls();
      const start = () => {
        if (!this.isConnected || navigator.connection?.saveData) return;
        this.loadCounts().catch(() => {});
        if (this.hasFilters(this.applied)) this.loadCatalog().then(() => this.renderProducts()).catch(() => {});
      };
      if ('requestIdleCallback' in window) this.idle = requestIdleCallback(start, { timeout: 3000 });
      else this.idle = setTimeout(start, 1800);
    }
    disconnectedCallback() {
      this.panelAnimation?.cancel();
      this.panelAnimation = null;
      this.controller?.abort();
      this.controller = null;
      this.resize?.disconnect();
      cancelAnimationFrame(this.railViewportFrame);
      this.railViewportFrame = null;
      this.gridObserver?.disconnect();
      if ('cancelIdleCallback' in window) cancelIdleCallback(this.idle);
      else clearTimeout(this.idle);
      if (this.dialog?.open) {
        this.dialog.close();
        document.documentElement.style.overflow = this.oldOverflow || '';
      }
    }
    openPanel(mode, opener) {
      const alreadyOpen = this.dialog.open;
      const from = alreadyOpen ? getComputedStyle(this.dialog).transform : 'translateY(100%)';
      this.panelAnimation?.cancel();
      this.panelMode = mode;
      this.panelOpener = opener;
      this.draft = { ...this.applied };
      this.draftSort = new URL(document.baseURI).searchParams.get('sort_by') || this.labels.defaultSort;
      this.dialog.querySelector('[data-filter-body]').hidden = mode === 'sort';
      this.dialog.querySelector('[data-sort-body]').hidden = mode !== 'sort';
      this.dialog.querySelector('h2').textContent = mode === 'sort' ? this.labels.sortTitle : this.labels.filterTitle;
      this.renderControls();
      if (!alreadyOpen) {
        this.oldOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        this.dialog.showModal();
      }
      this.dialog.querySelector('.jbr-dialog-body').scrollTop = 0;
      opener.setAttribute('aria-expanded', 'true');
      this.dialog.querySelector('[data-close]').focus({ preventScroll: true });
      this.animatePanel(true, from);
      if (mode !== 'sort') this.loadCatalog().catch(() => {});
    }
    animatePanel(opening, from) {
      this.dialog.dataset.motion = opening ? 'opening' : 'closing';
      if (reduced.matches || !this.dialog.animate) {
        if (!opening) this.dialog.close();
        else this.dialog.dataset.motion = 'open';
        return Promise.resolve();
      }
      const animation = this.dialog.animate(
        [{ transform: from === 'none' ? 'translateY(0)' : from }, { transform: opening ? 'translateY(0)' : 'translateY(100%)' }],
        { duration: opening ? 460 : 380, easing: opening ? 'cubic-bezier(.22,.61,.36,1)' : 'cubic-bezier(.4,0,.2,1)', fill: 'both' }
      );
      this.panelAnimation = animation;
      return animation.finished.catch(() => {}).then(() => {
        if (this.panelAnimation !== animation) return;
        if (!opening) this.dialog.close();
        this.dialog.dataset.motion = opening ? 'open' : 'closed';
        animation.cancel();
        this.panelAnimation = null;
      });
    }
    closePanel() {
      if (!this.dialog.open) return Promise.resolve();
      const from = getComputedStyle(this.dialog).transform;
      this.panelAnimation?.cancel();
      return this.animatePanel(false, from);
    }
    updateHeader() {
      const header = document.querySelector('#header');
      if (header) this.style.setProperty('--jbr-header', Math.round(header.getBoundingClientRect().height) + 'px');
      this.updateRailViewport();
    }
    updateRailViewport() {
      if (!this.rail || !this.railScroller || !matchMedia('(min-width:768px)').matches) return;
      const scrollbarWidth = Math.max(0, this.railScroller.offsetWidth - this.railScroller.clientWidth) + 'px';
      if (this.style.getPropertyValue('--jbr-scrollbar-width') !== scrollbarWidth) this.style.setProperty('--jbr-scrollbar-width', scrollbarWidth);
      const viewportHeight = window.visualViewport?.height || window.innerHeight;
      const railTop = Math.max(0, this.rail.getBoundingClientRect().top);
      const bottomGap = document.getElementById('PBarNextFrame') ? 84 : 24;
      const height = Math.max(120, Math.floor(viewportHeight - railTop - bottomGap - 12));
      const value = height + 'px';
      if (this.style.getPropertyValue('--jbr-rail-height') !== value) this.style.setProperty('--jbr-rail-height', value);
    }
    readURL() {
      const params = new URL(document.baseURI).searchParams;
      this.applied = {
        shape: params.get('jb_shape') || '',
        metal: ['white', 'yellow', 'rose'].includes(params.get('jb_metal')) ? params.get('jb_metal') : '',
        band: ['plain', 'pave'].includes(params.get('jb_band')) ? params.get('jb_band') : ''
      };
    }
    writeURL() {
      const url = new URL(document.baseURI);
      for (const key of ['shape', 'metal', 'band']) {
        if (this.applied[key]) url.searchParams.set('jb_' + key, this.applied[key]);
        else url.searchParams.delete('jb_' + key);
      }
      if (this.hasFilters(this.applied)) url.searchParams.delete('page');
      if (/^https?:$/.test(location.protocol)) history.pushState({}, '', url);
    }
    hasFilters(state) { return !!(state.shape || state.band || state.metal); }
    async loadCounts() {
      let next = new URL(this.dataset.collectionUrl, document.baseURI);
      next.searchParams.set('view', 'jb-catalog-count');
      const theme = new URL(document.baseURI).searchParams.get('preview_theme_id');
      if (theme) next.searchParams.set('preview_theme_id', theme);
      let count = 0;
      const visited = new Set();
      while (next) {
        if (visited.has(next.href)) break;
        visited.add(next.href);
        const response = await fetch(next, { credentials: 'same-origin', signal: this.controller.signal });
        if (!response.ok) return;
        const data = await response.json();
        count += data.count;
        next = data.next ? new URL(data.next, document.baseURI) : null;
        if (next && theme) next.searchParams.set('preview_theme_id', theme);
      }
      if (!this.catalog) this.eligibleTotal = count;
      this.updateProgress();
    }
    updateProgress() {
      const filtered = this.hasFilters(this.applied);
      const total = filtered && this.catalog ? this.matching(this.applied).length : this.eligibleTotal;
      const models = this.querySelector('.jb-catalog-models');
      if (models && total != null) models.textContent = this.labels.count.replace('__COUNT__', total);
      const progress = this.querySelector('[data-list-progress]');
      if (progress) {
        const count = [...this.grid.children].filter(node => node.querySelector('product-card')).length;
        progress.textContent = this.labels.showing.replace('__COUNT__', count);
      }
    }
    updateFacets() {
      if (!this.catalog) return;
      const records = this.catalog.flatMap(product => product.records);
      for (const key of ['shape', 'band']) {
        const available = new Set(records.flatMap(record => key === 'shape' ? record.shapeKeys : [record.band]).filter(Boolean));
        this.querySelectorAll('[data-facet="' + key + '"]').forEach(facet => { facet.hidden = !available.size; });
        this.querySelectorAll('[data-key="' + key + '"]').forEach(button => { button.disabled = !available.has(button.dataset.value); });
      }
      this.querySelectorAll('[data-key="metal"]').forEach(button => { button.disabled = !records.some(record => record.metalKeys.includes(button.dataset.value)); });
    }
    renderActive() {
      const area = this.querySelector('[data-active-filters]');
      if (!area) return;
      const nodes = [];
      for (const key of ['shape', 'metal', 'band']) {
        const value = this.applied[key];
        if (!value) continue;
        const option = [...this.querySelectorAll('[data-key]')].find(button => button.dataset.key === key && button.dataset.value === value);
        const label = option?.dataset.optionLabel || value;
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'jbr-chip';
        button.dataset.removeFilter = key;
        button.setAttribute('aria-label', this.labels.remove.replace('__VALUE__', label));
        button.textContent = label + ' ×';
        nodes.push(button);
      }
      if (nodes.length) {
        const clear = document.createElement('button');
        clear.type = 'button';
        clear.className = 'jbr-clear';
        clear.dataset.reset = '';
        clear.textContent = this.labels.clearAll;
        nodes.push(clear);
      }
      area.replaceChildren(...nodes);
      area.hidden = !nodes.length;
    }
    async loadCatalog() {
      if (this.catalog) return this.catalog;
      if (this.loading) return this.loading;
      this.setError(false);
      this.loading = (async () => {
        const products = [];
        let next = new URL(this.dataset.collectionUrl, document.baseURI);
        next.searchParams.set('view', 'jb-refinement-data');
        const sorting = new URL(document.baseURI).searchParams.get('sort_by');
        if (sorting) next.searchParams.set('sort_by', sorting);
        const theme = new URL(document.baseURI).searchParams.get('preview_theme_id');
        if (theme) next.searchParams.set('preview_theme_id', theme);
        const visited = new Set();
        while (next) {
          if (visited.has(next.href)) throw new Error('Repeated catalog page');
          visited.add(next.href);
          const response = await fetch(next.href, { credentials: 'same-origin', signal: this.controller.signal });
          if (!response.ok) throw new Error('Catalog request failed');
          const data = await response.json();
          products.push(...data.products);
          next = data.next ? new URL(data.next, document.baseURI) : null;
          if (next && theme) next.searchParams.set('preview_theme_id', theme);
          if (next && sorting) next.searchParams.set('sort_by', sorting);
        }
        this.catalog = products.map(product => {
          product.records = product.records.map(record => ({
            ...record,
            metalKeys: metalKeys(record.metal),
            metalKey: metalKeys(record.metal)[0] || '',
            shapeKeys: [...new Set([record.shape, ...(record.shapes || [])].filter(Boolean))],
            band: normalize(record.band) || bandMap[product.handle] || ''
          }));
          product.records.sort((a, b) => Number(b.metalKeys.includes('white')) - Number(a.metalKeys.includes('white')));
          return product;
        });
        this.eligibleTotal = this.catalog.length;
        this.updateFacets();
        this.renderControls();
        this.updateProgress();
        return this.catalog;
      })();
      try { return await this.loading; }
      catch (error) { this.setError(true); throw error; }
      finally { this.loading = null; this.renderControls(); }
    }
    setError(show) {
      for (const node of this.querySelectorAll('[data-error],[data-mobile-error]')) {
        node.hidden = !show;
        node.textContent = this.labels.error;
      }
    }
    matching(state) {
      return (this.catalog || []).flatMap(product => {
        const records = product.records.filter(record =>
          (!state.metal || record.metalKeys.includes(state.metal)) &&
          (!state.shape || record.shapeKeys.includes(state.shape)) &&
          (!state.band || record.band === state.band)
        );
        return records.length ? [{ product, record: records[0] }] : [];
      });
    }
    renderControls() {
      for (const button of this.querySelectorAll('[data-key]')) {
        const state = button.dataset.scope === 'panel' ? this.draft : this.pendingState || this.applied;
        button.setAttribute(button.getAttribute('role') === 'checkbox' ? 'aria-checked' : 'aria-pressed', String(state[button.dataset.key] === button.dataset.value));
      }
      const count = Number(!!this.applied.shape) + Number(!!this.applied.band) + Number(!!this.applied.metal);
      this.querySelector('[data-filter-count]').textContent = count ? '· ' + count : '';
      this.querySelector('.jbr-rail [data-reset]').hidden = count === 0;
      const matches = this.catalog ? this.matching(this.draft).length : null;
      this.querySelector('[data-match-count]').textContent = matches === null ? this.labels.loading : matches + ' ' + this.labels.creations;
      this.querySelector('[data-no-results]').hidden = this.panelMode === 'sort' || matches !== 0;
      this.querySelector('[data-match-count]').hidden = this.panelMode === 'sort';
      this.querySelector('[data-apply]').disabled = this.panelMode === 'sort' ? false : matches === null || matches === 0;
      this.querySelectorAll('[data-sort-value]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.sortValue === this.draftSort)));
      this.renderActive();
    }
    async apply(state) {
      const revision = ++this.revision;
      this.pendingState = { ...state };
      this.renderControls();
      this.setAttribute('aria-busy', 'true');
      this.status.textContent = this.labels.loading;
      try {
        await this.loadCatalog();
        if (revision !== this.revision || !this.isConnected) return;
        this.applied = { ...state };
        this.pendingState = null;
        this.draft = { ...state };
        this.limit = 24;
        this.writeURL();
        this.renderControls();
        this.renderProducts();
      } catch { if (revision === this.revision) { this.pendingState = null; this.renderControls(); } }
      finally { if (revision === this.revision) this.removeAttribute('aria-busy'); }
    }
    imageURL(src, width = 770) {
      const filename = decodeURIComponent(src.split('?')[0].split('/').pop());
      const url = new URL(this.labels.retouch?.[filename] || src, document.baseURI);
      url.searchParams.set('width', width);
      return url.href;
    }
    makeCard(product, record) {
      const key = product.handle + '|' + record.variant + '|' + record.metalKey;
      if (this.cards.has(key)) return this.cards.get(key);
      const li = document.createElement('li');
      li.className = 'column';
      li.dataset.jbrHandle = product.handle;
      li.dataset.jbrShape = record.shape;
      li.dataset.jbrMetal = record.metalKey;
      li.dataset.jbrBand = record.band;
      const card = document.createElement('product-card');
      card.className = 'product-card text-center';
      card.dataset.jbQuoteProduct = 'true';
      card.dataset.jbProductId = product.id;
      const figure = document.createElement('figure');
      figure.className = 'product-card--featured-image';
      const url = new URL(product.url, document.baseURI);
      if (record.variant) url.searchParams.set('variant', record.variant);
      const link = document.createElement('a');
      link.href = url.pathname + url.search;
      link.className = 'product-card--featured-image-link aspect-ratio aspect-ratio--square';
      link.style.paddingBottom = '100%';
      link.setAttribute('aria-label', product.title);
      const image = document.createElement('img');
      image.className = 'product-primary-image no-blur';
      image.width = 1000;
      image.height = 1000;
      image.loading = 'lazy';
      image.decoding = 'async';
      image.src = this.imageURL(record.photos[0].src);
      image.srcset = this.imageURL(record.photos[0].src, 375) + ' 375w, ' + image.src + ' 770w';
      image.sizes = '(max-width:767px) 45vw, (max-width:1100px) 30vw, 24vw';
      image.alt = record.photos[0].alt || product.title;
      link.append(image);
      figure.append(link);
      const save = document.createElement('button');
      save.type = 'button';
      save.className = 'jb-card-save';
      save.dataset.jbSave = product.handle;
      save.dataset.jbWishlistTitle = product.title;
      save.dataset.jbWishlistUrl = url.pathname + url.search;
      save.dataset.jbWishlistImage = image.src;
      save.setAttribute('aria-label', this.labels.save);
      save.setAttribute('aria-pressed', 'false');
      save.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true"><path d="M12 20.5 3.9 12.7C-2 6.8 6.2.1 12 6.1 17.8.1 26 6.8 20.1 12.7Z" stroke-width="1.1"/></svg>';
      figure.append(save);
      const info = document.createElement('div');
      info.className = 'product-card-info';
      const copy = document.createElement('div');
      copy.className = 'jb-card-copy';
      const inner = document.createElement('div');
      inner.className = 'jb-card-copy__inner';
      copy.append(inner);
      const title = document.createElement('a');
      title.className = 'product-card-title';
      title.href = link.href;
      title.textContent = new DOMParser().parseFromString(product.title, 'text/html').body.textContent;
      inner.append(title);
      const request = document.createElement('quick-view');
      request.className = 'jb-card-request jbr-request';
      request.dataset.productHandle = product.handle;
      request.setAttribute('role', 'button');
      request.tabIndex = 0;
      request.setAttribute('aria-haspopup', 'dialog');
      request.textContent = this.labels.request;
      info.append(copy, request);
      const media = document.createElement('jb-card-media');
      media.dataset.jbVerifiedGallery = 'true';
      for (const photo of record.photos) {
        const source = document.createElement('span');
        source.hidden = true;
        source.dataset.jbPhoto = '';
        source.dataset.src = this.imageURL(photo.src);
        source.dataset.alt = photo.alt || product.title;
        figure.append(source);
      }
      const progress = document.createElement('span');
      progress.className = 'jb-card-media-progress';
      progress.setAttribute('aria-hidden', 'true');
      const status = document.createElement('span');
      status.className = 'jb-card-media-status visually-hidden';
      status.setAttribute('role', 'status');
      figure.append(progress, status);
      media.append(figure);
      card.append(media, info);
      li.append(card);
      this.cards.set(key, li);
      return li;
    }
    renderProducts() {
      if (!this.catalog || !this.grid) return;
      const filtered = this.hasFilters(this.applied);
      const before = new Map([...this.grid.children].map(node => [node.dataset.jbrHandle, node.getBoundingClientRect()]));
      if (filtered) {
        const matches = this.matching(this.applied);
        this.grid.replaceChildren(...matches.slice(0, this.limit).map(({product,record}) => this.makeCard(product, record)));
        this.more.hidden = matches.length <= this.limit;
        this.empty.hidden = matches.length > 0;
        for (const node of this.pagination) node.hidden = true;
        this.status.textContent = matches.length + ' ' + this.labels.creations;
        const models = this.querySelector('.jb-catalog-models');
        if (models) {
          models.textContent = this.labels.count.replace('__COUNT__', matches.length);
        }
      } else {
        this.grid.replaceChildren(...this.original);
        for (const node of this.pagination) node.hidden = false;
        this.more.hidden = true;
        this.empty.hidden = true;
        const models = this.querySelector('.jb-catalog-models');
        if (models) models.textContent = this.eligibleTotal == null ? this.labels.creations : this.labels.count.replace('__COUNT__', this.eligibleTotal);
        this.status.textContent = '';
      }
      if (!reduced.matches) {
        for (const node of this.grid.children) {
          const old = before.get(node.dataset.jbrHandle);
          if (!old) continue;
          const now = node.getBoundingClientRect();
          if (Math.abs(old.left-now.left) > 1 || Math.abs(old.top-now.top) > 1) node.animate([{transform:'translate('+(old.left-now.left)+'px,'+(old.top-now.top)+'px)'},{transform:'translate(0,0)'}], {duration:240,easing:'cubic-bezier(.2,.65,.3,1)'});
        }
      }
      this.updateProgress();
      this.dispatchEvent(new CustomEvent('jb:catalog-updated', { bubbles:true }));
    }
    onClick(event) {
      const button = event.target.closest('button');
      if (!button || button.disabled) return;
      if (button.hasAttribute('data-remove-filter')) {
        const state = { ...this.applied, [button.dataset.removeFilter]: '' };
        this.apply(state);
        return;
      }
      if (button.hasAttribute('data-expand')) {
        const expanded = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(expanded));
        button.setAttribute('aria-label', expanded ? this.labels.outlines : this.labels.photographs);
        button.textContent = expanded ? '−' : '+';
        this.querySelector('[data-outline]').hidden = expanded;
        const photographs = this.querySelector('[data-photographs]');
        photographs.hidden = !expanded;
        if (!reduced.matches) (expanded ? photographs : this.querySelector('[data-outline]')).animate([{transform:'translateY(-5px)'},{transform:'translateY(0)'}],{duration:220,easing:'cubic-bezier(.2,.65,.3,1)'});
        this.loadCatalog().catch(() => {});
        return;
      }
      if (button.hasAttribute('data-accordion')) {
        const expanded = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(expanded));
        const content = button.nextElementSibling;
        content.inert = !expanded;
        content.setAttribute('aria-hidden', String(!expanded));
        return;
      }
      if (button.hasAttribute('data-open-sort')) { this.openPanel('sort', button); return; }
      if (button.hasAttribute('data-open')) { this.openPanel('filter', button); return; }
      if (button.hasAttribute('data-sort-value')) {
        this.draftSort = button.dataset.sortValue;
        this.renderControls();
        return;
      }
      if (button.hasAttribute('data-close')) { this.closePanel(); return; }
      if (button.hasAttribute('data-clear')) { this.draft = defaults(); this.renderControls(); this.loadCatalog().catch(() => {}); return; }
      if (button.hasAttribute('data-reset')) { this.apply(defaults()); return; }
      if (button.hasAttribute('data-apply')) {
        if (button.disabled) return;
        if (this.panelMode === 'sort') {
          const url = new URL(document.baseURI);
          if (this.draftSort === this.labels.defaultSort) url.searchParams.delete('sort_by');
          else url.searchParams.set('sort_by', this.draftSort);
          url.searchParams.delete('page');
          this.closePanel().then(() => { if (url.href !== location.href) location.assign(url.href); });
        } else {
          this.apply({ ...this.draft });
          this.closePanel();
        }
        return;
      }
      if (!button.dataset.key) return;
      const state = button.dataset.scope === 'panel' ? { ...this.draft } : { ...(this.pendingState || this.applied) };
      const { key, value } = button.dataset;
      state[key] = state[key] === value ? '' : value;
      if (!reduced.matches) {
        const target = button.querySelector('.jbr-band-disc,.jbr-swatch,.jbr-diamond-picture img,.jbr-faceted');
        if (target) target.animate([{scale:1},{scale:1.045},{scale:1}],{duration:240,easing:'cubic-bezier(.2,.65,.3,1)'});
      }
      if (button.dataset.scope === 'panel') { this.draft = state; this.renderControls(); this.loadCatalog().catch(() => {}); }
      else this.apply(state);
    }
  }
  customElements.define('jb-collection-refinements', JBRefinements);
})();



